export const appsettings = {
  //apiUrl: "https://localhost:7101/api/",
  apiUrl: "https://sanuchiha-001-site1.ctempurl.com/api/",

  escenarios: [
    "1. Domination",
    "2. To the Death",
    "3. Hold Ground",
    "4. Destroy the Supplies",
    "5. Reconnoitre",
    "6. Fog of War",
    "7. Capture and Control",
    "8. Breakthrough",
    "9. Stake a Claim",
    "10. Lords of Battle",
    "11. Assassination",
    "12. Contest of Champions",
    "13. Heirlooms of Ages Past",
    "14. Sites of Power",
    "15. Command the Battlefield",
    "16. Retrieval",
    "17. Seize the Prizes",
    "18. Treasure Hoard",
    "19. Storm the Camp",
    "20. Divide and Conquer",
    "21. Escort the Wounded",
    "22. Clash by Moonlight",
    "23. Lead from the Front",
    "24. Convergence",
  ],

  armies: [
    // Good
    // Facciones de Luz (Good), ordenadas alfabéticamente
    { name: "Atop the Wall", band: "good", shortName: "AtW" },
    { name: "Army of Edoras", band: "good", shortName: "AoEdo" },
    { name: "Breaking of the Fellowship", band: "good", shortName: "BotF" },
    { name: "Defenders of Helm's Deep", band: "good", shortName: "DoHD" },
    { name: "Defenders of the Hornburg", band: "good", shortName: "DotH" },
    { name: "Defenders of the Pelennor", band: "good", shortName: "DotP" },
    { name: "Fangorn", band: "good", shortName: "Fan" },
    { name: "Garrison of Ithilien", band: "good", shortName: "GoI" },
    { name: "Kingdom of Rohan", band: "good", shortName: "KoR" },
    { name: "Lindon", band: "good", shortName: "Lin" },
    { name: "Lothlorien", band: "good", shortName: "Loth" },
    { name: "Men of the West", band: "good", shortName: "MotW" },
    { name: "Minas Tirith", band: "good", shortName: "MT" },
    { name: "Numenor", band: "good", shortName: "N" },
    { name: "Realms of Men", band: "good", shortName: "RoMen" },
    { name: "Reclamation of Osgiliath", band: "good", shortName: "RoO" },
    { name: "Return of the King", band: "good", shortName: "RotK" },
    { name: "Ride Out", band: "good", shortName: "RO" },
    { name: "Riders of Eomer", band: "good", shortName: "RoE" },
    { name: "Riders of Theoden", band: "good", shortName: "RoT" },
    { name: "Rivendell", band: "good", shortName: "Riv" },
    { name: "Road to Helm's Deep", band: "good", shortName: "RtHD" },
    { name: "Road to Rivendell", band: "good", shortName: "RtR" },
    { name: "The Eagles", band: "good", shortName: "TE" },
    { name: "The Fellowship", band: "good", shortName: "TF" },
    { name: "The Last Alliance", band: "good", shortName: "TLA" },
    { name: "The Shire", band: "good", shortName: "TS" },

    { name: "Army of Lake-town", band: "good", shortName: "AoLT" },
    { name: "Army of Thror", band: "good", shortName: "AoT" },
    { name: "Assault on Ravenhill", band: "good", shortName: "AoR" },
    { name: "Defenders of Dale", band: "good", shortName: "DoD" },
    { name: "Erebor & Dale", band: "good", shortName: "E&D" },
    { name: "Erebor Reclaimed", band: "good", shortName: "ER" },
    { name: "Garrison of Dale", band: "good", shortName: "GoD" },
    { name: "Halls of Thranduil", band: "good", shortName: "HoT" },
    { name: "Iron Hills", band: "good", shortName: "IH" },
    { name: "Radagast's Alliance", band: "good", shortName: "RA" },
    { name: "Rangers of Mirkwood", band: "good", shortName: "RoMir" }, // RoM ya existe → agregamos un número
    { name: "Survivors of Lake-town", band: "good", shortName: "SoLT" },
    { name: "The Battle of Five Armies", band: "good", shortName: "TBoFA" },
    { name: "The White Council", band: "good", shortName: "TWC" },
    { name: "Thorin's Company", band: "good", shortName: "TC" },

    { name: "Arathorn’s Stand", band: "good", shortName: "AS" },
    { name: "Arnor", band: "good", shortName: "Arn" },
    { name: "Army de Dale", band: "good", shortName: "AdD" },
    { name: "Army of Erebor", band: "good", shortName: "AoEre" },
    { name: "Battle of Bywater", band: "good", shortName: "BoB" },
    { name: "Battle of Fornost", band: "good", shortName: "BoF" },
    { name: "Defenders of Erebor", band: "good", shortName: "DoE" },
    { name: "Fords of Isen", band: "good", shortName: "FoI" },
    { name: "Kingdom of Khazad-dum", band: "good", shortName: "KoK" },
    { name: "Paths of the Druadan", band: "good", shortName: "PotD" },
    { name: "The Beornings", band: "good", shortName: "Beor" },
    { name: "The Fiefdoms", band: "good", shortName: "Fief" },
    { name: "The Grief of Eomer", band: "good", shortName: "TGoE" },
    { name: "The Grey Company", band: "good", shortName: "TGC" },

    {
      name: "Battle of Grrenfields (legacy)",
      band: "good",
      shortName: "BoG(L)",
    },
    { name: "Fields of Celebrant (legacy)", band: "good", shortName: "FoC(L)" },
    {
      name: "Reclamation of Moria (legacy)",
      band: "good",
      shortName: "RoM(L)",
    },
    {
      name: "Expedition to the East (legacy)",
      band: "good",
      shortName: "EtE(L)",
    },

    // Facciones de Oscuridad (Evil), ordenadas alfabéticamente
    { name: "Army of the White Hand", band: "evil", shortName: "AotWH" },
    { name: "Army of Gothmog", band: "evil", shortName: "AoG" },
    { name: "Assault Upon Helm's Deep", band: "evil", shortName: "AUHD" },
    { name: "Barad-Dur", band: "evil", shortName: "Barad" },
    { name: "Besiegers of the Hornburg", band: "evil", shortName: "BotH" },
    { name: "Cirith Ungol", band: "evil", shortName: "CU" },
    { name: "Corsair Fleets", band: "evil", shortName: "CF" },
    { name: "Depths of Moria", band: "evil", shortName: "DoM" },
    { name: "Harad", band: "evil", shortName: "Har" },
    { name: "Legions of Mordor", band: "evil", shortName: "LoM" },
    { name: "Lurtz's Scouts", band: "evil", shortName: "LS" },
    { name: "Minas Morgul", band: "evil", shortName: "MM" },
    { name: "Muster of Isengard", band: "evil", shortName: "MoI" },
    { name: "The Black Gate", band: "evil", shortName: "TBG" },
    { name: "The Black Riders", band: "evil", shortName: "TBR" },
    { name: "The Iron Hills", band: "evil", shortName: "TIH" },
    { name: "Ugluk's Scouts", band: "evil", shortName: "US" },
    { name: "Usurpers of Edoras", band: "evil", shortName: "UoE" },
    { name: "Wraiths on Wings", band: "evil", shortName: "WoW" },
    { name: "Wolves of Isengard", band: "evil", shortName: "WoI" },

    { name: "Army of Gundabad", band: "evil", shortName: "AoGu" },
    { name: "Azog's Hunters", band: "evil", shortName: "AH" },
    { name: "Desolator of the North", band: "evil", shortName: "DotN" },
    { name: "Goblin-town", band: "evil", shortName: "Gobl" },
    { name: "Pits of Dol Guldur", band: "evil", shortName: "PoDG" },
    { name: "Rise of the Necromancer", band: "evil", shortName: "RotN" },
    { name: "The Three Trolls", band: "evil", shortName: "TTT" },

    { name: "Army of Carn Dum", band: "evil", shortName: "AoCD" },
    { name: "Buhrdur’s Horde", band: "evil", shortName: "Buhr" },
    { name: "Host of the Witch-king", band: "evil", shortName: "HotWK" },
    { name: "Shadows of Angmar", band: "evil", shortName: "SoA" },
    { name: "Wolf Pack of Angmar", band: "evil", shortName: "WPoA" },
    { name: "Army of the Great Eye", band: "evil", shortName: "AotGE" },
    { name: "Sharkey´s Rogues", band: "evil", shortName: "SR" },
    { name: "Moria", band: "evil", shortName: "Mori" },
    { name: "Dragons of the North", band: "evil", shortName: "DotN" },
    { name: "The Eastelings", band: "evil", shortName: "East" },
    { name: "Host of the Dragon Emperor", band: "evil", shortName: "HotDE" },
    { name: "The Serpent Horde", band: "evil", shortName: "TSH" },
    { name: "Umbar", band: "evil", shortName: "Umba" },
    { name: "Grand Army of the South", band: "evil", shortName: "GAotS" },

    {
      name: "Fell Beings of Mirkwood (legacy)",
      band: "evil",
      shortName: "FBM(L)",
    },
    {
      name: "Assault on Lothlórien (legacy)",
      band: "evil",
      shortName: "AoL(L)",
    },
    { name: "Army of Dunland (legacy)", band: "evil", shortName: "AoD(L)" },
    { name: "Variangs of Khand (legacy)", band: "evil", shortName: "VoK(L)" },
    { name: "Far Harad (legacy)", band: "evil", shortName: "FH(L)" },
    {
      name: "Ravagers of the Shire (legacy)",
      band: "evil",
      shortName: "RotS(L)",
    },
    {
      name: "The Spider Queen´s Brood (legacy)",
      band: "evil",
      shortName: "TSQB(L)",
    },
  ],
};
